import swal from "sweetalert";

document.addEventListener("DOMContentLoaded", () => {
	$.nette.ext("product-added-alert", {
		success: function (e) {
			if (e.hasOwnProperty("showProductAdded")) {
				swal({
					title: e.showProductAdded,
					icon: "success",
					button: {
						text: "OK",
						className: "btn btn-primary",
						closeModal: true,
						value: true,
						visible: true
					},
					closeOnEsc: true,
					closeOnClickOutside: true,
					timer: 2000
				});
			}

			if (e.hasOwnProperty("wishlistProductId")) {
				const wishlistProductId = e.wishlistProductId;

				$("#add-to-wishlist-" + wishlistProductId).find("i").removeClass("mdi-heart-outline").addClass("mdi-heart");
			}
		}
	});
});
